import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { ScheduleService } from '../schedule-service';
import { AddScheduleRequest, ScheduleJobDetail, SCHEDULE_TYPES } from '../schedule.types';

@Component({
    selector: 'add-schedule-dialog',
    templateUrl: './add-schedule-dialog.component.html',
    styleUrls: ['./add-schedule-dialog.component.scss'],
})
export class AddScheduleDialog implements OnInit {

    scheduleTypes: string[] = SCHEDULE_TYPES;
    jobDetails: ScheduleJobDetail[] = [];

    jobType: string = '';
    scheduleType: string = 'None';
    scheduleDate: Date = new Date();
    scheduleTime: string;

    isLoading: boolean = true;
    isSaving: boolean = false;
    error: string = '';

    constructor(
        public dialogRef: MatDialogRef<AddScheduleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private scheduleService: ScheduleService
    ) {
        this.scheduleTime = moment().format('HH:mm');
    }

    ngOnInit(): void {
        this.scheduleService.getJobNames().subscribe({
            next: (details) => {
                this.jobDetails = details;
                if (details.length) {
                    this.jobType = details[0].shortName;
                }
                this.isLoading = false;
            },
            error: () => {
                this.error = 'Could not load the list of tasks.';
                this.isLoading = false;
            }
        });
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onCreate(): void {
        if (!this.jobType) {
            this.error = 'Please choose a task.';
            return;
        }

        if (!this.scheduleDate) {
            this.error = 'Please choose a date.';
            return;
        }

        const timeParts = (this.scheduleTime || '00:00').split(':');
        const hours = +timeParts[0];
        const minutes = +timeParts[1];

        const scheduleMoment = moment(this.scheduleDate)
            .hours(hours)
            .minutes(minutes)
            .seconds(0)
            .milliseconds(0);

        const request: AddScheduleRequest = {
            jobType: this.jobType,
            scheduleType: this.scheduleType,
            scheduleTime: scheduleMoment.format(),
        };

        this.isSaving = true;
        this.error = '';
        this.scheduleService.addSchedule(request).subscribe({
            next: (result) => {
                this.isSaving = false;
                if (result.success) {
                    this.dialogRef.close(true);
                } else {
                    this.error = result.error || 'Something went wrong creating the scheduled task.';
                }
            },
            error: () => {
                this.isSaving = false;
                this.error = 'Something went wrong creating the scheduled task.';
            }
        });
    }
}
